import { render, staticRenderFns } from "./SubCard.vue?vue&type=template&id=0b45975e&scoped=true&lang=pug"
import script from "./SubCard.vue?vue&type=script&lang=js"
export * from "./SubCard.vue?vue&type=script&lang=js"
import style0 from "./SubCard.vue?vue&type=style&index=0&id=0b45975e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b45975e",
  null
  
)

export default component.exports